import type { ChipProps } from './Chip';

export type OldChipProps = Omit<ChipProps, 'deletable'> & {
  /** @deprecated deletable을 대신 사용해주세요. */
  canDelete?: boolean;
};

export function convertOldChipProps(props: OldChipProps): ChipProps {
  const { canDelete, ...restProps } = props;

  return {
    ...restProps,
    deletable: canDelete,
  };
}
